import * as _ from 'lodash';
import React, { FC } from 'react';
import {
  Filter,
  NumberInput,
  TextInput,
  ReferenceInput,
  AutocompleteInput,
} from "react-admin";

const ListFilter: FC<any> = (props) => (
  <Filter {...props}>
    <NumberInput source="id" />
    <TextInput source="name" />
    <NumberInput source="sequenceNo" />
    <ReferenceInput
      source="courseId"
      reference="courses"
      resource="sections"
      filterToQuery={(searchText: any) => {
        return _.isEmpty(_.trim(searchText)) ? null : { name: searchText };
      }}>
      <AutocompleteInput optionText="name" fullWidth />
    </ReferenceInput>
  </Filter>
);

export default ListFilter;
